import { useLayoutEffect } from 'react'
import useDeviceSize from './useDeviceSize';

function useMobileSectionNavigation({ location }) {
  const deviceSizes = useDeviceSize();

  useLayoutEffect(() => {
    if (deviceSizes.lgDown && location.pathname) {
      const id = location?.state?.sectionId;
      setTimeout(() => {
        const elem = document.getElementById(id);
        if (elem) {
          elem.scrollIntoView({ behavior: 'smooth' })
        }
      }, 1000)
    }
  }, [location?.pathname])
}

export default useMobileSectionNavigation